
const ResultsSection = () => {
  const caseStudies = [
    {
      company: 'LocalCraft Bakery',
      industry: 'Food & Beverage',
      challenge: 'Local bakery wanted to sell online',
      result: '400% revenue increase in 6 months',
      metrics: [
        { label: 'Revenue Growth', value: '400%', icon: 'ri-arrow-up-line' },
        { label: 'Online Orders', value: '2,500+', icon: 'ri-shopping-cart-line' },
        { label: 'Search Ranking', value: '#1', icon: 'ri-trophy-line' }
      ],
      image: 'https://public.readdy.ai/ai/img_res/8cebbfb4aea1ed45bb5b20006095e5fe.jpg'
    },
    {
      company: 'TechGear Pro',
      industry: 'Electronics',
      challenge: 'E-commerce store struggling with visibility',
      result: 'Dominated top 3 rankings for 50+ keywords',
      metrics: [
        { label: 'Keyword Rankings', value: '50+', icon: 'ri-search-line' },
        { label: 'Organic Traffic', value: '800%', icon: 'ri-line-chart-line' },
        { label: 'Conversion Rate', value: '12.5%', icon: 'ri-percent-line' }
      ],
      image: 'https://readdy.ai/api/search-image?query=High-tech%20electronics%20store%20with%20modern%20gadgets%2C%20sleek%20product%20displays%2C%20and%20professional%20e-commerce%20photography%20in%20a%20minimalist%20tech%20showroom&width=600&height=400&seq=tech-case&orientation=landscape'
    },
    {
      company: 'FitLife Supplements',
      industry: 'Health & Wellness',
      challenge: 'Needed to scale across US markets',
      result: 'Expanded to 15 states with 600% growth',
      metrics: [
        { label: 'Market Expansion', value: '15 States', icon: 'ri-map-pin-line' },
        { label: 'Revenue Growth', value: '600%', icon: 'ri-money-dollar-circle-line' },
        { label: 'Customer Base', value: '10,000+', icon: 'ri-group-line' }
      ],
      image: 'https://readdy.ai/api/search-image?query=Premium%20fitness%20supplements%20and%20health%20products%20arranged%20in%20a%20modern%20clean%20laboratory%20setting%20with%20professional%20product%20photography%20and%20scientific%20equipment&width=600&height=400&seq=supplements-case&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-green-50 border border-green-200 rounded-full text-green-700 text-sm font-medium mb-6">
            <i className="ri-trophy-line mr-2"></i>
            Success Stories
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Real Businesses,
            <span className="text-indigo-600"> Real Results</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            See how we've transformed local businesses into online powerhouses and helped e-commerce stores dominate their markets.
          </p>
        </div>

        {/* Case Studies */}
        <div className="space-y-16">
          {caseStudies.map((study, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              {/* Image */}
              <div className="flex-1">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src={study.image} 
                    alt={study.company}
                    className="w-full h-80 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1">
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-sm font-medium">
                      {study.industry}
                    </div>
                  </div>
                  
                  <h3 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {study.company}
                  </h3>
                  
                  <p className="text-gray-600 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
                    <strong>Challenge:</strong> {study.challenge}
                  </p>
                  
                  <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
                    <p className="text-green-800 font-semibold" style={{ fontFamily: 'Inter, sans-serif' }}>
                      <i className="ri-check-double-line mr-2"></i>
                      {study.result}
                    </p>
                  </div>

                  {/* Metrics */}
                  <div className="grid grid-cols-3 gap-4">
                    {study.metrics.map((metric, metricIndex) => (
                      <div key={metricIndex} className="text-center">
                        <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-2">
                          <i className={`${metric.icon} text-indigo-600`}></i>
                        </div>
                        <div className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
                          {metric.value}
                        </div>
                        <div className="text-sm text-gray-600" style={{ fontFamily: 'Inter, sans-serif' }}>
                          {metric.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-indigo-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              Ready to Be Our Next Success Story?
            </h3>
            <p className="text-indigo-100 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Join hundreds of businesses that have transformed their online presence with our proven strategies.
            </p>
            <button className="bg-white text-indigo-600 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
              <i className="ri-rocket-line mr-2"></i>
              Start Your Transformation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
